import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce, noop as _$no, map as _$ma, createUnknownComponentVNode as _$cc } from 'intact-vue-next';
import { DescriptionItem } from './item';
import { makeStyles } from './styles';
import { getRestProps } from '../utils';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className,
    columns = _this$get.columns,
    title = _this$get.title,
    vertical = _this$get.vertical,
    items = _this$get.items;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-descriptions"] = true, _classNameObj[k + "-vertical"] = vertical, _classNameObj[className] = className, _classNameObj[makeStyles(k, columns)] = true, _classNameObj);
  return _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj)
  }), [$blocks.title || title ? _$ce(2, 'div', (_$blocks['title'] = function ($super) {
    return title ? title : undefined;
  }, __$blocks['title'] = function ($super, data) {
    var block = $blocks['title'];
    var callBlock = function callBlock() {
      return _$blocks['title'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['title'](_$no)), 0, _$cn(k + "-descriptions-title")) : undefined, _$ce(2, 'div', items ? _$ma(items, function ($value, $key) {
    return _$cc(DescriptionItem, {
      'label': $value.label,
      'content': $value.content,
      'append': $value.append
    });
  }, $this) : children, 0, _$cn(k + "-descriptions-content"))]);
}
;